import * as classNames from 'classnames';
import * as React from 'react';

import { DisplayType, NoticeItem as NoticeItemType, Item } from './Notice';
import { NoticeItem } from './items/NoticeItem';
import { BookBenefit, NoticeBenefitItem } from './items/NoticeBenefitItem';
import { BookEvent, NoticeEventItem } from './items/NoticeEventItem';
import { LinkedContent, NoticeLinkedContentsItem } from './items/NoticeLinkedContentsItem';
import styled from "@emotion/styled";

const ShowMore = styled.li`
  padding: 5px 0;
  font-size: 12px;
  cursor: pointer;
  button {
    font-size: 12px;
    color: #808991;
  }
`

interface Props {
  header: string;
  type: string;
  items?: Array<NoticeItemType> | undefined;
}

export function NoticeList(props: Props) {
  const { header, type, items } = props;
  const [isToggled, setToggle] = React.useState(false);

  const renderItems = (item: NoticeItemType, index: number) => {
    const key = `${type}-${index}`;

    switch (type) {
      case DisplayType.LINKED_CONTENTS: {
        return (
          <NoticeLinkedContentsItem
            item={item as LinkedContent[]}
            key={key}
          />
        );
      }
      case DisplayType.EVENTS: {
        return <NoticeEventItem event={item as BookEvent} key={key} />;
      }
      case DisplayType.BENEFIT: {
        return <NoticeBenefitItem {...item as BookBenefit} key={key}/>
      }
      default: {
        return (
          <NoticeItem
            item={item as Item}
            key={key}
          />
        );
      }
    }
  };


  // 이벤트가 3개 초과면 토글하는 기능
  function renderToggleItems() {
    if(items.length < 1 || type !== 'events') {
      return null;
    }
    return (
      <>
        <ul className="BookDetailNotice_List_Group">
          {items.slice(0, !isToggled ? 2 : items.length ).map((item, index) => {
            return renderItems(item, index);
          })}
        </ul>
        { !isToggled && items.length > 2 &&
          <ul className="BookDetailNotice_List_Group">
            <ShowMore onClick={() => setToggle(true)}><button role="button">이벤트 더보기</button></ShowMore>
          </ul>
        }
      </>
    )
  }

  return items && items.length ? (
    <div className="BookDetailNotice_List">
      <div
        className={classNames(
          'BookDetailNotice_List_Header',
          `BookDetailNotice_List_Header-${type}`,
        )}
      >
        {header}
      </div>
      {
        type !== 'events' ?
          <ul className="BookDetailNotice_List_Group">
            {items.map((item, index) => {
              return renderItems(item, index);
            })}
          </ul>
          : renderToggleItems()
      }

    </div>
  ) : null;
};



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/NoticeList.tsx